import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { Tournament } from '../../../../types/MTT';

import { TXTCLI_Satellite_to } from './SatelliteInfo.messages.json';
import styles from './SatelliteInfo.scss';

export interface BuyInProps {
  tournament: Tournament;
  className?: string;
}
const SatelliteInfo: React.FC<BuyInProps> = ({ tournament, className = '' }) => {
  const isEmbedded = useSelector(select.device.isDesktopEmbedded);
  const { formattedSatelliteTargetName: name, satelliteTarget } = tournament;
  const showLink = isEmbedded && name && satelliteTarget;

  const handleSatelliteToClick = () => {
    if (showLink) window.starsweb?.app?.execute(`tournament/${satelliteTarget}`);
  };

  if (!name) {
    return null;
  }

  return (
    <div className={classNames(styles.root, className)}>
      <Translation {...TXTCLI_Satellite_to} />{' '}
      <span
        className={classNames(styles.name, {
          [styles.button]: showLink
        })}
        onClick={handleSatelliteToClick}
      >
        {name}
      </span>
    </div>
  );
};

export default SatelliteInfo;
